'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'bell-ring';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e62c';
var svgPathData = ['M64 371.7c0 6.8 5.5 12.3 12.3 12.3l359.4 0c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2l0-29.1c0-69-54.6-125.3-123-127.9c-1.7-.1-3.3-.1-5-.1s-3.4 0-5 .1C182.6 66.7 128 123 128 192l0 29.1c0 52.2-20.7 102.3-57.7 139.2L67.6 363c-2.3 2.3-3.6 5.4-3.6 8.7z', 'M240 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16.8c80.9 8 144 76.2 144 159.2l0 29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3L76.3 416C51.8 416 32 396.2 32 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C78.6 306.7 96 264.8 96 221.1L96 192c0-83 63.1-151.2 144-159.2L240 16zm16 48c-70.7 0-128 57.3-128 128l0 29.1c0 52.2-20.7 102.3-57.7 139.2L67.6 363c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3l359.4 0c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2l0-29.1c0-70.7-57.3-128-128-128zM225.8 458.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C307.6 494.2 283.9 512 256 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8zM119.4 21.8c5.7 6.8 4.7 16.9-2.1 22.5C74.9 79.5 48 132.6 48 192c0 8.8-7.2 16-16 16s-16-7.2-16-16C16 122.7 47.5 60.8 96.9 19.7c6.8-5.7 16.9-4.7 22.5 2.1zM397.8 44.3c-6.8-5.7-7.7-15.7-2.1-22.5s15.7-7.7 22.5-2.1c49.4 41.1 80.9 103 80.9 172.3c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-59.4-26.9-112.5-69.3-147.7z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBellRing = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;